var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSelvagginaRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5601 16.49C30.3301 17.17 32.6001 21.37 33.3301 22.17C34.9101 23.9 41.6501 27.91 43.3301 28.17C43.6901 28.23 44.4601 28.08 44.7901 28.13C45.5801 28.24 45.9701 28.72 46.4401 29.15C47.3001 32.07 44.7501 36.25 40.6201 39.21C36.8301 40.65 32.6001 40.37 29.3301 39.17L23.3301 38.17",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.33 40.1699C35.13 41.9599 31.88 42.7299 27.41 42.4699C18.95 41.9699 15.01 47.1699 5.53003 47.1699",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40002 10.23C8.40002 9.50996 12.54 8.74996 16.56 9.61996L17.3 9.52995C18.65 8.06995 26.55 3.65996 29.38 2.82996C29.3 6.88996 26.18 15.51 18.38 20.01",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.91 40.1599C36.56 38.2499 37.2 36.0299 37.32 34.0699C37.38 33.1099 36.96 32.5699 36.3 33.2799C34.7 34.9899 33.82 36.8699 33.39 39.4499",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelvagginaRed);
export default __webpack_public_path__ + "static/media/ic_selvaggina_red.9852df080296cb454cfbebc42ba5f032.svg";
export { ForwardRef as ReactComponent };